import {FC, ReactNode} from 'react'
// import {useLocation, useParams} from 'react-router-dom'
// import {useAuth} from '../app/modules/auth'
import {WithChildren} from '../_metronic/helpers'
// import {getTitle} from './CustomFunctions'

type Props = {
  permission: 'is_view' | 'is_edit' | 'is_delete' | 'is_add'
  alt?: ReactNode
  title?: string
  model?: string
}

// export const Permission: FC<Props & WithChildren> = ({children, permission, alt, title, model}) => {
//   const {pathname} = useLocation()
//   const {['*']: param} = useParams()
//   if (!title) {
//     title = model || getTitle(param ? pathname.split('/' + param)[0] : pathname)
//   }
//   const {currentUser} = useAuth()
//   const visible = () => {
//     let res = false
//     const result = currentUser?.find(
//       (p) => p.operation?.operation_slug === title!.replace(/ /g, '-').toLowerCase()
//     )
//     if (result && result.operation && result.operation[`${permission}_visible`])
//       res = result[permission] || false
//     return res
//   }
//   return null // visible() ? <>{children}</> : <>{alt}</>
// }


// import {FC} from 'react'
// import {useLocation, useParams} from 'react-router-dom'
// import {WithChildren} from '../react18MigrationHelpers'
// import {useAuth} from '../hooks/useAuth'
// import {getTitle} from '../helpers'

// type Props = {
//   permission: 'create' | 'read' | 'update' | 'delete'
//   alt?: JSX.Element
//   title?: string
//   model?: string
// }

export const Permission: FC<Props & WithChildren> = ({children, permission, alt, title, model}) => {
  // const {pathname} = useLocation()
  // const {['*']: param} = useParams()
  // const {currentUser} = useAuth()

  // const derivedTitle = title || model || getTitle(param ? pathname.split('/' + param)[0] : pathname)
  // const slug = derivedTitle?.replace(/ /g, '-').toLowerCase()

  // const visible = () => {
  //   if (!currentUser || !slug) return false

  //   // const result = currentUser.find(
  //   //   (p) => p.operation?.operation_slug === slug
  //   // )

  //   return !!(result?.operation?.[`${permission}_visible`] && result?.[permission])
  // }

  // return visible() ? <>{children}</> : alt ?? null
return <>{children}</>
}